<template>
    <div>
        <b-card no-body>
            <b-card-body>
                <h4 class="heading-1 mb-4">
                    <span>CONTRATOS - SERVIÇOS</span>
                    <div class="float-right">
                        <span class="text-primary">
                            <i
                                class="fa fa-refresh fa-lg icon-button"
                                title="Atualizar"
                                @click.stop="obterComprometimentos()"
                            ></i>
                        </span>
                    </div>
                </h4>
                <b-row>
                    <b-col sm="12" md="6">
                        <b-form-group>
                            <label>Contrato</label>
                            <model-list-select
                                :list="contratos"
                                option-text="codContratoFornecedor"
                                option-value="codContrato"
                                v-model="codContrato"
                            >
                            </model-list-select>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="3">
                        <b-form-group>
                            <strong>
                                <label>Data Emissão (DE)</label>
                            </strong>
                            <date-picker
                                ref="dp01"
                                v-model="dataInicial"
                                :config="$datePickerOptions2"
                                v-mask="'##/##/####'"
                                placeholder="Informe a data inicial"
                            ></date-picker>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="3">
                        <b-form-group>
                            <strong>
                                <label>Data Emissão (ATÉ)</label>
                            </strong>
                            <date-picker
                                ref="dp02"
                                v-model="dataFinal"
                                :config="$datePickerOptions2"
                                v-mask="'##/##/####'"
                                placeholder="Informe a data final"
                            ></date-picker>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="4">
                        <b-form-group>
                            <strong>
                                <label>Por Status</label>
                            </strong>
                            <b-form-select
                                :plain="true"
                                :options="statusSelect"
                                v-model="status"
                            ></b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="4">
                        <b-form-group>
                            <strong>
                                <label>Por Situação do Comprometimento</label>
                            </strong>
                            <b-form-select
                                :plain="true"
                                :options="situacoesComprometimentoSelect"
                                v-model="situacaoComprometimento"
                            ></b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="2">
                        <div class="mt-4 pt-1">
                            <b-button
                                @click.stop="obterComprometimentos()"
                                variant="primary"
                                >Pesquisar</b-button
                            >
                        </div>
                    </b-col>
                </b-row>
                <!-- <b-alert
                    show
                    variant="warning"
                    v-if="contrato && contrato.tipoEspecial"
                >
                    <h5>Atenção</h5>
                    <p>
                        Esse contrato requer documento(s) comprobatório(s)
                        anexado(s) ao serviço, para que este possa ser enviado
                        para análise.
                    </p>
                </b-alert> -->
                <app-tabela
                    :itens="comprometimentos"
                    :campos="campos"
                    :itensPorPagina="itensPorPagina"
                    :bordered="false"
                    :small="false"
                >
                    <template slot="botoes">
                        <slot name="botoes"></slot>
                    </template>
                    <template slot="valor" slot-scope="data">{{
                        data.valor | currency
                    }}</template>
                    <template slot="idRm" slot-scope="data">
                        {{ data.idRm }}
                        <status-id-mov :comprometimento="data"></status-id-mov>
                    </template>
                    <template slot="acoes" slot-scope="data">
                        <span
                            class="text-warning"
                            v-if="data.contratoTipoEspecial"
                        >
                            <i
                                class="fa fa-exclamation-triangle fa-lg"
                                title="Esse contrato requer documento(s) comprobatório(s)
                        anexado(s) ao serviço, para que este possa ser enviado
                        para análise."
                            ></i>
                        </span>
                        <comprometimento-anexos
                            :comprometimento="data"
                            :dataServico="obterComprometimentosServicos()"
                            :mostrarBtnInserir="mostrarBtnInserir(data)"
                            :mostrarBtnExcluir="mostrarBtnExcluir(data)"
                            @obter-atualizacao="obterComprometimentos()"
                        ></comprometimento-anexos>
                        <comprometimento-enviar-para-analise
                            :contratoTipoEspecial="data.contratoTipoEspecial"
                            :comprometimento="data"
                            :dataServico="obterComprometimentosServicos()"
                            @obter-atualizacao="obterComprometimentos()"
                        >
                        </comprometimento-enviar-para-analise>
                        <comprometimento-cancelar-envio-para-analise
                            :comprometimento="data"
                            :dataServico="obterComprometimentosServicos()"
                            @obter-atualizacao="obterComprometimentos()"
                        >
                        </comprometimento-cancelar-envio-para-analise>
                        <comprometimento-aprovadores
                            :comprometimento="data"
                            :dataServico="obterComprometimentosServicos()"
                        >
                        </comprometimento-aprovadores>
                        <btn-justificativas-reprovacao
                            :comprometimento="data"
                        ></btn-justificativas-reprovacao>
                    </template>
                </app-tabela>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import ComprometimentoAnexos from './ComprometimentoAnexos'
import ComprometimentoEnviarParaAnalise from './ComprometimentoEnviarParaAnalise'
import ComprometimentoAprovadores from './ComprometimentoAprovadores'
import { comprometimentoStatus } from './ComprometimentoStatus'
import BtnJustificativasReprovacao from './BtnJustificativasReprovacao'
import ComprometimentosServicos from './ComprometimentosServicos2'
import ComprometimentoCancelarEnvioParaAnalise from './ComprometimentoCancelarEnvioParaAnalise'
import StatusIdMov from './StatusIdMov'
import { ModelListSelect } from 'vue-search-select'

export default {
    data() {
        return {
            contratos: [],
            codContrato: '',
            dataInicial: null,
            dataFinal: null,
            statusSelect: [
                { text: 'TODOS', value: -2 },
                { text: 'EM ABERTO', value: 0 },
                { text: 'EM ANÁLISE', value: 1 },
                { text: 'APROVADO', value: 2 },
                { text: 'REPROVADO', value: 3 }
            ],
            status: -2,
            situacoesComprometimentoSelect: [
                { text: 'TODOS', value: -2 },
                { text: 'NÃO COMPROMETIDO', value: 1 },
                { text: 'COMPROMETIDO COM SUCESSO', value: 4 },
                { text: 'VINCULADO A UM PAGAMENTO', value: 5 }
            ],
            situacaoComprometimento: -2,
            comprometimentos: [],
            erros: [],
            campos: [
                {
                    key: 'acoes',
                    label: 'Ações',
                    tdClass: 'text-center'
                },
                {
                    key: 'contrato',
                    label: 'Contrato',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap text-center'
                },
                {
                    key: 'idComprometimento',
                    label: 'Id',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'processo',
                    label: 'Processo',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'tipo',
                    label: 'Tipo',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap',
                    type: 'status'
                },
                {
                    key: 'dataEmissao',
                    label: 'Data de Emissão',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap text-center',
                    type: 'date'
                },
                {
                    key: 'dataMovimento',
                    label: 'Data do Movimento',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap text-center',
                    type: 'date'
                },
                {
                    key: 'historico',
                    label: 'Descritivo',
                    filterable: true
                },
                {
                    key: 'valor',
                    label: 'Valor',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'idRm',
                    label: 'ID RM',
                    tdClass: 'text-nowrap text-center'
                },
                {
                    key: 'situacao',
                    label: 'Situação',
                    type: 'status'
                },
                {
                    key: 'statusDescr',
                    label: 'Status',
                    type: 'status'
                },
                {
                    key: 'qtdAnexos',
                    label: 'Qtd. Anexos'
                },
                {
                    key: 'dataAtualizacao',
                    label: 'Atualizado em',
                    type: 'datetime',
                    tdClass: 'text-nowrap text-center'
                }
            ],
            itensPorPagina: 10
        }
    },

    methods: {
        obterContratos() {
            this.$store.dispatch('addRequest')
            ComprometimentosServicos.obterContratos().then((response) => {
                if (response) {
                    if (response.success) {
                        this.contratos = response.data
                        this.contratos.unshift({
                            codContrato: '',
                            codContratoFornecedor: 'TODOS'
                        })
                    } else {
                        this.erros = ['Erro ao obter contratos']
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterComprometimentos() {
            this.$store.dispatch('addRequest')
            let filtroDto = {
                contrato: this.codContrato
                    ? this.codContrato.replace('/', '-')
                    : '',
                status: this.status,
                situacao: this.situacaoComprometimento,
                dataInicial: this.dataInicial
                    ? this.$moment(this.dataInicial, 'DD/MM/YYYY').format(
                          'YYYY-MM-DD'
                      )
                    : '',
                dataFinal: this.dataFinal
                    ? this.$moment(this.dataFinal, 'DD/MM/YYYY').format(
                          'YYYY-MM-DD'
                      )
                    : ''
            }
            ComprometimentosServicos.obterComprometimentos(filtroDto).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.comprometimentos = response.data
                        } else {
                            this.erros = ['Erro ao obter serviços']
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        obterComprometimentosServicos() {
            return ComprometimentosServicos
        },

        mostrarBtnInserir(comprometimento) {
            return (
                (comprometimento.status == comprometimentoStatus.EM_ABERTO ||
                    comprometimento.status ==
                        comprometimentoStatus.REPROVADO) &&
                this.$temAcessoView('CONT-COMPR-11')
            )
        },

        mostrarBtnExcluir(comprometimento) {
            return (
                (comprometimento.status == comprometimentoStatus.EM_ABERTO ||
                    comprometimento.status ==
                        comprometimentoStatus.REPROVADO) &&
                this.$temAcessoView('CONT-COMPR-11')
            )
        }
    },

    created() {
        this.obterContratos()
        let dataAtual = new Date()
        this.dataInicial = this.$moment(dataAtual)
            .subtract(2, 'months')
            .startOf('month')
            .format('DD/MM/YYYY')
        this.dataFinal = this.$moment(dataAtual)
            .endOf('month')
            .format('DD/MM/YYYY')
    },

    computed: {},

    watch: {},

    components: {
        ComprometimentoAnexos,
        ComprometimentoEnviarParaAnalise,
        ComprometimentoAprovadores,
        BtnJustificativasReprovacao,
        ComprometimentoCancelarEnvioParaAnalise,
        StatusIdMov,
        ModelListSelect
    }
}
</script>
